import React, { createContext, useMemo, useContext, useState, useEffect } from 'react';

interface SettingsContextType {
  showSubmenus: boolean;
  setShowSubmenus: (show: boolean) => void;
}

const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

export const SettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showSubmenus, setShowSubmenus] = useState(() => {
    const stored = localStorage.getItem('showSubmenus');
    return stored ? JSON.parse(stored) : true;
  });

  useEffect(() => {
    localStorage.setItem('showSubmenus', JSON.stringify(showSubmenus));
  }, [showSubmenus]);

  return (
    <SettingsContext.Provider value={useMemo(() => ({ showSubmenus, setShowSubmenus }), [showSubmenus])}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (context === undefined) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};